
import React from 'react';
import { FaEye,  FaFacebook, FaInstagram, FaTwitter, FaEnvelope, FaLandmark, FaPhone,  FaYoutube, FaWhatsapp    } from 'react-icons/fa';



const Banner = ({handleServices, handleContact}) => {
   const date = new Date();
    const currentYear = date.getFullYear();
  return (
    
        
        <div className='container-fluid banner-footer-container'>
             <div className="d-flex flex-column align-items-center gap-2 custom-banner-footer">

            <h1 className='custom-title'>Peerless<span>Glam</span></h1>
            <p> We provide impeccable styles and solutions to suit your needs. </p>
            <p> Quality at its peak...</p>
            <button className="custom-service-btn" onClick={handleServices}>  View Our Services <FaEye fontSize={16} color='white'/> </button>

            <div className='footer'>

                <h1>Contact Us</h1>
                <p className="email-address" onClick={handleContact} ><FaEnvelope fontSize={15} color='gray'/>  peerlessglam@gmail.com</p>

                <p><FaLandmark fontSize={15} color='gray'/> Lagos State, Nigeria</p>
                <a className='whatsap-a' href='https://wa.me/2348157579775?text=Hello%20welcome!%20how%20can%20i%20help%20you?' target='_blank' rel="noreferrer" ><p className='whatsapp'><FaPhone fontSize={15} color='gray'/>+234 8157579775<FaWhatsapp color='gray'/></p></a>
                <div className='socials'>
                     <a href="https://www.facebook.com/peerlessglam1" target="_blank" rel="noreferrer"><FaFacebook fontSize={20} color='blue' /></a>
                    <a href="https://www.instagram.com/peerless_glam1" target="_blank" rel="noreferrer"><FaInstagram fontSize={20} color='purple'/></a>
                    <a href="https://www.twitter.com/@PeerlessGlam" target="_blank" rel="noreferrer"><FaTwitter fontSize={20} color='#1AA7EC' /></a>
                    <a href="https://www.youtube.com/channel/UCtYNgtNq8tO8KjeAEN6LI5A/videos" target="_blank" rel="noreferrer"><FaYoutube fontSize={20} color='rgb(252, 47, 81)'/></a>
                </div>
                 <div className="copyright">
                        <p>Created by PGTech<span>&copy;</span>{currentYear}</p>
                        
            </div>
         </div>

            </div>  
        </div>
        

    
  )
}

export default Banner
